function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var l = function l(e) {
  return typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e;
},
    u = function u(e) {
  return !e || _typeof(e) != "object" || Object.keys(e).length === 0;
},
    x = function x(e, o) {
  return JSON.stringify(e) === JSON.stringify(o);
},
    A = function A(e) {
  return typeof e == "boolean";
};

function i(e, o) {
  e.forEach(function (r) {
    Array.isArray(r) ? i(r, o) : o.push(r);
  });
}

function y(e) {
  var o = [];
  return i(e, o), o;
}

var a = function a() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }

  return y(e).filter(Boolean);
},
    p = function p(e, o) {
  var r = {},
      c = Object.keys(e),
      f = Object.keys(o);

  for (var _i = 0, _c = c; _i < _c.length; _i++) {
    var t = _c[_i];

    if (f.includes(t)) {
      var s = e[t],
          n = o[t];
      Array.isArray(s) || Array.isArray(n) ? r[t] = a(n, s) : _typeof(s) == "object" && _typeof(n) == "object" ? r[t] = p(s, n) : r[t] = n + " " + s;
    } else r[t] = e[t];
  }

  for (var _i2 = 0, _f = f; _i2 < _f.length; _i2++) {
    var _t = _f[_i2];
    c.includes(_t) || (r[_t] = o[_t]);
  }

  return r;
},
    g = function g(e) {
  return !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();
};

export { l as a, u as b, x as c, A as d, y as e, a as f, p as g, g as h };